import { Grid } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const ECGrid = styled(Grid)`
  margin-top: 8px !important;

  @media (max-width: 520px) {
    overflow-wrap: anywhere;
  }
`;
